/**
 * @author gyb(mocheer)
 * @since 2017.5.20
 * 
 */
let { Util, TileLayer } = L;
/**
 * 腾讯地图
 */
export default TileLayer.extend({
  getTileUrl: function (coords) {
    return Util.template(this._url, T.assign({
      s: this._getSubdomain(coords),
      x: coords.x,
      y: Math.pow(2, coords.z) - 1 - coords.y,
      z: coords.z
    }, this.options));
  }
})



// WEBPACK FOOTER //
// ./src/provider/TencentMap.js